import { createModel } from '@rematch/core';

import { RootModel } from '.';

interface FilterOptions {
  [filterKey: string]: string[] | number[] | boolean | undefined;
}

interface State {
  filters: {
    [filterGroup: string]: FilterOptions;
  };
}

export const initialState: State = {
  filters: {
    freelancerFilters: {
      roles: [],
      departments: [],
      team_leads: [],
      employment_types: [],
      countries: [],
      categories: [],
      companies: [],
      subunits: [],
      gender: [],
    },
  },
};

export const filters = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setFilterGroup(
      state,
      payload: {
        filterGroup: string;
        newOptions: FilterOptions;
      },
    ) {
      return {
        ...state,
        filters: {
          ...state.filters,
          [payload.filterGroup]: payload.newOptions,
        },
      };
    },
    updateFilter(
      state,
      payload: {
        filterGroup: string;
        filterKey: string;
        value: string[] | number[] | boolean | undefined;
      },
    ) {
      return {
        ...state,
        filters: {
          ...state.filters,
          [payload.filterGroup]: {
            ...state.filters[payload.filterGroup],
            [payload.filterKey]: payload.value,
          },
        },
      };
    },
    resetFilterGroup(state, filterGroup: string) {
      return {
        ...state,
        filters: {
          ...state.filters,
          [filterGroup]: initialState.filters[filterGroup],
        },
      };
    },
  },
  effects: (dispatch) => ({}),
});
